import React from 'react';
import './CTA.css';

const CTA = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="pilot" className="cta">
      <div className="container">
        <h2>Ready to revolutionize your farming?</h2>
        <p>Join farmers worldwide who are already saving water, reducing costs, and increasing yields with our automated drip irrigation system.</p>
        <button onClick={() => scrollToSection('contact')} className="btn btn-primary btn-large">
          Get Started Today
        </button>
      </div>
    </section>
  );
};

export default CTA;
